import { defaultButton, defaultId, defaultStatus, defaultStatusMsg, defaultStyle, defaultTime, noEditStyle } from "./shared.js";

// Custom functions for table columns.
const clickButton = (props, params) => {
    props.browser.navigate(`/translations/audio/${params.row.id}`);
};

const createTitle = (props, params) => {
    return "Listen";
};

const disableButton = (props, params) => {
    return params.row.status !== "PROCESSED";
};

// Column definitions.
const resource = (props) => ({
    ...noEditStyle,
    field: "resource.name",
    headerName: "Resource",
    flex: 0.2,
    minWidth: 175,
    valueGetter: (params) => params.row?.translation?.resource?.name ?? "N/A"
});
const text = {
    ...defaultStyle,
    field: "translation.text",
    headerName: "Transcript",
    flex: 0.25,
    minWidth: 200,
    valueGetter: (params) => params.row?.translation?.text ?? "N/A"
};
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus() };
const statusMsg = { ...defaultStatusMsg };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, disabled: disableButton, title: createTitle }), minWidth: 100, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [defaultId, resource(props), text, status, createdOn, updatedOn, statusMsg, action(props)];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
